import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { AtsJobResponse, HttpResponse } from "@/types";

export function useGetOrphanedAtsJobs() {
  return useQuery({
    queryKey: ["orphaned-ats-jobs"],
    queryFn: async () => {
      const path = "ats-jobs/orphaned";
      const res = await guacHttpClient.get<
        AtsJobResponse[],
        HttpResponse<AtsJobResponse[]>
      >(path);
      return res.data;
    },
  });
}
